<div class="p-3">
  <accordion>
    @if (!_shared.routerAuth.restricted_buttons.financed_contract_stats) {
      <accordion-group  class="mb-3 financed-contracts-accordion" heading="Financed Contracts (Overall)" [isOpen]="opened" [panelClass]="'dashboard-cards'"
        >
        <div class="row">
          <div class="col-md-3 col-sm-6 col-12 mb-3">
            <div class="card bg-1 p-2" [routerLink]="'/app/contracts/list'"
              [queryParams]="{type:1, statusFilter:'0',extraFilter:0}">
              <h3>{{dashboard.financed_contracts ? dashboard.financed_contracts : '0.00'}}</h3>
              <h4 class="m-0">Total Financed Contracts</h4>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-12 mb-3">
            <div class="card bg-2 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
              [queryParams]="{type:0, sD:today_start_date, eD:today_end_date,extraFilter:0}">
              <!-- 1,2,4,5,6,7 -->
              <h3>{{dashboard.financed_contracts_today ? dashboard.financed_contracts_today : '0.00'}}</h3>
              <h4 class="m-0">Financed Contracts Today</h4>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-12 mb-3">
            <div class="card bg-3 p-2" [routerLink]="'/app/contracts/list'" [queryParams]="{type: 3, statusFilter:'3'}">
              <h3>{{dashboard.overdue_accounts ? dashboard.overdue_accounts : '0.00'}}</h3>
              <h4 class="mb-0">Total Overdue Contracts</h4>
            </div>
          </div>
          <!-- <div class="col-md-3 col-sm-6 col-12 mb-3">
          <div class="card bg-4 p-2" [routerLink]="'/app/contracts/legal'">
            <h3>{{dashboard.legal_overdue_contracts ? dashboard.legal_overdue_contracts : '0.00'}}</h3>
            <h4 class="m-0">Total Legal Contracts</h4>
          </div>
        </div> -->
        <div class="col-md-3 col-sm-6 col-12 mb-3">
          <div class="card bg-5 p-2 errored-div" [routerLink]="'/app/errors/business-errors'">
            <h3>{{dashboard.financing_errors ? dashboard.financing_errors : '0.00'}}</h3>
            <h4 class="m-0">Financing Errors (24 hours)</h4>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 col-12 mb-3">
          <div class="card bg-6 p-2">
            <h3>${{dashboard.late_fee ? dashboard.late_fee : '0.00'}}</h3>
            <h4 class="m-0">Total Late Fee</h4>
          </div>
        </div>
        <div class="col-md-3 col-sm-6 col-12 mb-3">
          <div class="card bg-7 p-2">
            <h3>{{dashboard.late_fee_count ? dashboard.late_fee_count : '0.00'}}</h3>
            <h4 class="m-0">Late Fee Count</h4>
          </div>
        </div>
        <!-- <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-8 p-2 highlighted-div" [routerLink]="'/app/fees/late'">
          <h3>{{country_sign}}{{dashboard.late_fee_today ? dashboard.late_fee_today : '0.00' | number :'1.1-3'}}</h3>
          <h4 class="m-0">Late Fee Today</h4>
        </div>
      </div> -->
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2">
          <h3>{{dashboard.late_fee_count_today ? dashboard.late_fee_count_today : '0.00'}}</h3>
          <h4 class="m-0">Late Fee Today Count</h4>
        </div>
      </div>
      <!-- <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-5 p-2" [routerLink]="'/app/contracts/manage-contracts'" [queryParams]="{type: 0}">
        <h3>{{country_sign}}{{dashboard.financed_amount ? dashboard.financed_amount : '0.00' | number :'1.1-3'}}</h3>
        <h4 class="m-0">Total Financed Amount</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-7 p-2" [routerLink]="'/app/contracts/manage-contracts'"
        [queryParams]="{type:0, sD:today_start_date, eD:today_end_date}">
        <h3>{{country_sign}}{{dashboard.financed_amount_today ? dashboard.financed_amount_today : '0.00' | number
        :'1.1-3'}}</h3>
        <h4 class="m-0">Financed Amount Today</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-3 p-2">
        <h3>{{country_sign}}{{dashboard.first_recurring_fee ? dashboard.first_recurring_fee : '0.00' | number
        :'1.1-3'}}</h3>
        <h4 class="m-0">Total Reserved First Recurring</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-3 p-2 highlighted-div">
        <h3>{{country_sign}}{{dashboard.today_first_recurring_fee ? dashboard.today_first_recurring_fee : '0.00' |
        number :'1.1-3'}}</h3>
        <h4 class="m-0">Reserved First Recurring Today</h4>
      </div>
    </div> -->
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-5 p-2 errored-div" [routerLink]="'/app/errors/split-errors'">
        <h3>{{dashboard.split_errors ? dashboard.split_errors : '0.00'}}</h3>
        <h4 class="m-0">Split Proposal Errors (24 hours)</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-7 p-2" [routerLink]="'/app/contract-changes/guaranteed-changes'"
        [queryParams]="{filter: 1, sD: minDates, eD: today_end_date}">
        <h3>{{pp_dashboard.total_non_guaranteed_gp_status_change}}</h3>
        <h4 class="m-0">GP to Non-GP</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-7 p-2" [routerLink]="'/app/contract-changes/guaranteed-changes'"
        [queryParams]="{filter: 2, sD: minDates, eD: today_end_date}">
        <h3>{{pp_dashboard.total_guaranteed_gp_status_change}}</h3>
        <h4 class="m-0">Non-GP to GP</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-3 p-2 highlighted-div">
        <h3>{{dashboard.pay_over_time_services ? dashboard.pay_over_time_services : '0.00'}}</h3>
        <h4 class="m-0">Web Connect Services</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-3 p-2 highlighted-div">
        <h3>{{dashboard.pay_over_time_contracts ? dashboard.pay_over_time_contracts : '0.00'}}</h3>
        <h4 class="m-0">Web Connect Total Contracts</h4>
      </div>
    </div>
    <!-- <div class="col-md-3 col-sm-6 col-12 mb-3">
    <div class="card bg-3 p-2 highlighted-div">
      <h3>{{country_sign}}{{dashboard.sum_of_pay_over_time_financed_amount ?
      dashboard.sum_of_pay_over_time_financed_amount : '0.00' | number :'1.1-3'}}</h3>
      <h4 class="m-0">Web Connect Total Financed Amount</h4>
    </div>
  </div> -->
  <div class="col-md-3 col-sm-6 col-12 mb-3">
    <div class="card bg-3 p-2 highlighted-div">
      <h3>{{dashboard.pay_over_time_contracts_today ? dashboard.pay_over_time_contracts_today : '0.00'}}</h3>
      <h4 class="m-0">Web Connect Contracts Today</h4>
    </div>
  </div>
  <div class="col-md-3 col-sm-6 col-12 mb-3">
    <div class="card bg-3 p-2 errored-div" [routerLink]="'/app/contracts/list'"
      [queryParams]="{type:1, sD:today_start_date, eD:today_end_date,extraFilter:36}">
      <h3>{{dashboard.pause_payment || '0'}}</h3>
      <h4 class="m-0">Pause Payments</h4>
    </div>
  </div>
  <!-- <div class="col-md-3 col-sm-6 col-12 mb-3">// TODO
  <div class="card bg-3 p-2 errored-div" [routerLink]="'/app/contracts/list'"
    [queryParams]="{type:0, sD:today_start_date, eD:today_end_date,extraFilter:37}">
    <h4>{{dashboard.credit_reporting_contracts || '0'}}</h4>
    <h4 class="m-0">Today's Contract with Credit Reporting</h4>
    <h6>Credit Reporting Opted : {{dashboard.opted_credit_reporting_contracts}}</h6>
    <h6>Credit Reporting Not Opted : {{dashboard.not_opted_credit_reporting_contracts}}</h6>
  </div>
</div> -->
<div class="col-md-3 col-sm-6 col-12 mb-3">
  <div class="card bg-3 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
    [queryParams]="{type:0, sD:minDates, eD:today_end_date,extraFilter:37,statusFilter:'0'}">
    <h4>{{dashboard.opted_credit_reporting_contracts_today || '0'}}</h4>
    <h4 class="m-0 mb-1">Opted In For Credit Reporting Today</h4>
    <!-- <h6>Credit Reporting Opted : {{dashboard.total_opted_credit_reporting_contracts}}</h6>  -->
    <h6>Option Available to {{dashboard.today_credit_reporting_contracts}} Contracts</h6>
  </div>
</div>
<div class="col-md-3 col-sm-6 col-12 mb-3">
  <div class="card bg-7 p-2" >
    <h3>{{country_sign}}{{dashboard.total_opted_credit_reporting_contracts ?
    dashboard.total_opted_credit_reporting_contracts : '0.00' | number :'1.1-3'}}</h3>
    <h4 class="m-0 mb-1">Total Opted In For Credit Reporting</h4>
    <div class="contract-optation d-flex">
      <h6>Option Available to {{dashboard.total_credit_reporting_contracts}} Contracts</h6>
      <!-- Trigger -->
      <p class="info" style="margin-left: 20px; text-decoration: underline;" (click)="openModal(reportingOTP)">View Info</p>
    </div>
  </div>
</div>
<!-- Modal -->
<ng-template #reportingOTP>
  <div class="modal-content border-0">
    <div class="modal-header w-100 d-flex align-items-center justify-content-between" style="background-color: #1d4a16;">
      <h5 class="modal-title" id="exampleModalCenterTitle" style="color: #ffff;">Finance Mutual Credit Reporting Otp-In Summary</h5>
      <img src="assets/images/icons/white-cross.svg" alt="" (click)="closeModal()" class="cursor hw-24">
    </div>
    <div class="modal-body">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div class="d-flex align-items-center">
          <select class="form-select form-select-sm" style="width: auto;" [(ngModel)]="selectedPeriod"
            (change)="reload()">
            <option>Weekly</option>
            <option>Monthly</option>
          </select>
        </div>
        <button class="btn btn-sm btn-outline-secondary border-0" (click)="reload()" title="Reload Data">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
            class="bi bi-arrow-clockwise" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z" />
            <path d="M8 4.466V.534l2.766 2.5L8 4.466z" />
          </svg>
        </button>
      </div>
      <div class="table-responsive">
        <table class="table table-sm table-striped table-hover mb-0" style="font-size: 0.9rem;">
          <thead class="table-data">
            <tr class="heading">
              <th class="text-center" style="border-top-left-radius: 12px; background: linear-gradient(135deg, #369b26, #1d4a16);">S.No.</th>
              <th class="text-center" style="background: linear-gradient(135deg, #369b26, #1d4a16);">From Date</th>
              <th class="text-center" style="background: linear-gradient(135deg, #369b26, #1d4a16);">To Date</th>
              <th class="text-center" style="background: linear-gradient(135deg, #369b26, #1d4a16);">Total Contracts</th>
              <th class="text-center" style="background: linear-gradient(135deg, #369b26, #1d4a16);">Contracts With Option</th>
              <th class="text-center" style="background: linear-gradient(135deg, #369b26, #1d4a16);">Opted In</th>
              <th class="text-center" style="background: linear-gradient(135deg, #369b26, #1d4a16);">Not Opted</th>
              <th class="text-center" style="background: linear-gradient(135deg, #369b26, #1d4a16);">Opt-In Rate</th>
              <th class="text-end" style="border-top-right-radius: 12px; background: linear-gradient(135deg, #369b26, #1d4a16);">Expected Amount</th>
            </tr>
          </thead>
          <tbody>
            @for (row of summaryData; track row; let i = $index) {
              <tr>
                <td class="text-center">{{ offset + i + 1 }}</td>
                <td>{{ row.fromDate | date : 'MM/dd/yyyy' : '+0000' }}</td>
                <td>{{ row.toDate | date : 'MM/dd/yyyy' : '+0000' }}</td>
                <td class="text-center">{{ row.totalContracts }}</td>
                <td class="text-center">{{ row.contractsWithOption }}</td>
                <td class="text-center text-success fw-bold">{{ row.optedIn }}</td>
                <td class="text-center text-danger fw-bold">{{ row.notOpted }}</td>
                <td class="text-center text-warning fw-bold">{{ row.optInRate }}</td>
                <td class="text-end">${{ row.expectedAmount }}</td>
              </tr>
            }
          </tbody>
          <tfoot style="background-color: #f8f9fa; font-weight: 800;">
            <tr class="total">
              <td colspan="3" class="text-start" style="background-color: #b2eea8; color: #1d4a16; font-size: 16px; font-weight: 600; border-bottom-left-radius: 10px; border-bottom: 0;" >Total</td>
              <td class="text-center" style="background-color: #b2eea8; color: #1d4a16; font-size: 16px; font-weight: 600; border-bottom: 0;">{{ summaryTotals.totalContracts }}</td>
              <td class="text-center" style="background-color: #b2eea8; color: #1d4a16; font-size: 16px; font-weight: 600; border-bottom: 0;">{{ summaryTotals.contractsWithOption }}</td>
              <td class="text-center" style="background-color: #b2eea8; color: #1d4a16; font-size: 16px; font-weight: 600; border-bottom: 0;">{{ summaryTotals.optedIn }}</td>
              <td class="text-center" style="background-color: #b2eea8; color: #1d4a16; font-size: 16px; font-weight: 600; border-bottom: 0;">{{ summaryTotals.notOpted }}</td>
              <td class="text-center" style="background-color: #b2eea8; color: #1d4a16; font-size: 16px; font-weight: 600; border-bottom: 0;">{{summaryTotals.optInRate}}</td>
              <td class="text-end" style="background-color: #b2eea8; color: #1d4a16; font-size: 16px; font-weight: 600; border-bottom-right-radius: 10px; border-bottom: 0;">${{ summaryTotals.expectedAmount }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="d-flex justify-content-end align-items-center mt-2 pb-2 pt-2">
        <nav>
          <ul class="pagination pagination-sm mb-0">
            <li class="page-item" [class.disabled]="offset === 0">
              <a class="page-link" (click)="goToPage(1)">First</a>
            </li>
            <li class="page-item" [class.disabled]="offset === 0">
              <a class="page-link" (click)="goToPage(offset/limit)">Previous</a>
            </li>
            <li class="page-item active">
              <a class="page-link">{{ (offset/limit) + 1 }}</a>
            </li>
            <li class="page-item" [class.disabled]="(offset+limit) >= totalRecords">
              <a class="page-link" (click)="goToPage((offset/limit)+2)">Next</a>
            </li>
            <li class="page-item" [class.disabled]="(offset+limit) >= totalRecords">
              <a class="page-link" (click)="goToPage(Math.ceil(totalRecords/limit))">Last</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</ng-template>
</div>
</accordion-group>
}

@if (!_shared.routerAuth.restricted_buttons.zero_contract_stats) {
  <accordion-group class="mb-3 financed-contracts-accordion"
    [heading]="environment.plans.secure.label + ' Financing Contracts'" [isOpen]="opened"
    [panelClass]="'dashboard-cards'">
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2" [routerLink]="'/app/contracts/list'"
          [queryParams]="{type:1, statusFilter:'0', extraFilter:9}">
          <h3>{{dashboard.zero_percent_contracts ? dashboard.zero_percent_contracts : '0.00'}}</h3>
          <h4 class="m-0">Total Contracts with {{environment.plans.secure.label}} Financing</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
          [queryParams]="{type:0, extraFilter:9, sD:today_start_date, eD:today_end_date, statusFilter:'1,2,3,4,5,6,7'}">
          <h3>{{dashboard.zero_percent_today_contracts ? dashboard.zero_percent_today_contracts : '0.00'}}</h3>
          <h4 class="m-0">{{environment.plans.secure.label}} Financing Contracts Today</h4>
        </div>
      </div>
      <!-- <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-3 p-2">
        <h3>{{country_sign}}{{(dashboard.upfront_fee ? dashboard.upfront_fee : '0.00') | number :'1.1-3'}}</h3>
        <h4 class="m-0">Total Upfront Fees</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-3 p-2 highlighted-div">
        <h3>{{country_sign}}{{dashboard.today_upfront_fee ? dashboard.today_upfront_fee : '0.00' | number :'1.1-3'}}
        </h3>
        <h4 class="m-0">Upfront Fees Today</h4>
      </div>
    </div> -->
  </div>
</accordion-group>
}

@if (!_shared.routerAuth.restricted_buttons.new_ten_contract_stats) {
  <accordion-group class="mb-3  financed-contracts-accordion"
    [heading]="environment.plans.max.label + ' Financing Contracts'" [isOpen]="opened"
    [panelClass]="'dashboard-cards'">
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2" [routerLink]="'/app/contracts/list'"
          [queryParams]="{type:1, extraFilter:26, statusFilter:'1,2,4,5,7'}">
          <h3>{{dashboard.new_ten_percent_contracts ? dashboard.new_ten_percent_contracts : '0.00'}}</h3>
          <h4 class="m-0">Total Contracts With {{environment.plans.max.label}} Financing</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
          [queryParams]="{type:0, extraFilter:26, sD:today_start_date, eD:today_end_date}">
          <h3>{{dashboard.new_ten_percent_today_contracts ? dashboard.new_ten_percent_today_contracts : '0.00'}}</h3>
          <h4 class="m-0">{{environment.plans.max.label}} Financing Contracts Today</h4>
        </div>
      </div>
    </div>
  </accordion-group>
}

@if (!_shared.routerAuth.restricted_buttons.split_request_stats) {
  <accordion-group  class="mb-3 financed-contracts-accordion" heading="Proposal Requests" [isOpen]="opened" [panelClass]="'dashboard-cards'"
    >
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-1 p-2" [routerLink]="'/app/proposal/list'">
          <h3>{{dashboard.total_split_requests ? dashboard.total_split_requests : '0.00'}}</h3>
          <h4 class="m-0">Total Requests Sent</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-2 p-2 highlighted-div" [routerLink]="'/app/proposal/list'"
          [queryParams]="{startDate: today_start_date, endDate: today_end_date}">
          <h3>{{dashboard.today_split_requests ? dashboard.today_split_requests : '0.00'}}</h3>
          <h4 class="m-0">Total Requests Sent Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-7 p-2" [routerLink]="'/app/proposal/list'" [queryParams]="{status: 4, startDate: dateRangeValue[0], endDate: dateRangeValue[1]}">
          <h3>{{dashboard.contract_financed_requests ? dashboard.contract_financed_requests : '0.00'}}</h3>
          <h4 class="m-0">Total Contracts Financed</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-8 p-2 highlighted-div normal-div">
          <h3>{{dashboard.today_contract_financed_requests ? dashboard.today_contract_financed_requests : '0.00'}}</h3>
          <h4 class="m-0">Total Contracts Financed Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 errored-div" [routerLink]="'/app/proposal/list'" [queryParams]="{status: 2}">
          <h3>{{dashboard.link_opened_requests ? dashboard.link_opened_requests : '0.00'}}</h3>
          <h4 class="mb-0">Total Link Opened</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-5 p-2 errored-div" [routerLink]="'/app/proposal/list'" [queryParams]="{status: 3}">
          <h3>{{dashboard.plan_selected_requests ? dashboard.plan_selected_requests : '0.00'}}</h3>
          <h4 class="m-0">Total Plan Selected</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-6 p-2 errored-div" [routerLink]="'/app/proposal/list'"
          [queryParams]="{status: 3, startDate: today_start_date, endDate: today_end_date, by: 'plan_selected_date', order: 'DESC', 'sortBy': 6}">
          <h3>{{dashboard.today_plan_selected_requests ? dashboard.today_plan_selected_requests : '0.00'}}</h3>
          <h4 class="m-0">Total Plan Selected Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 normal-div">
          <h3>{{dashboard.deleted_split_requests ? dashboard.deleted_split_requests : '0.00'}}</h3>
          <h4 class="m-0">Total Deleted Requests</h4>
        </div>
      </div>
    </div>
  </accordion-group>
}

@if (!_shared.routerAuth.restricted_buttons.doctor_stats) {
  <accordion-group  class="mb-3 financed-contracts-accordion" heading="Businesses" [isOpen]="opened" [panelClass]="'dashboard-cards card-primary'"
    >
    <div class="row ">
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-1 p-2" [routerLink]="'/app/business/list'"
          [queryParams]="{status: 1, country_id: country_id}">
          <h3>{{dashboard.active_doctors ? dashboard.active_doctors : '0.00'}}</h3>
          <h4 class="m-0">Total Businesses</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-2 p-2" [routerLink]="'/app/business/list'"
          [queryParams]="{action: 16, startDate:today_start_date, endDate:today_end_date}">
          <h3>{{dashboard.active_doctors_today ? dashboard.active_doctors_today : '0.00'}}</h3>
          <h4 class="m-0">Businesses Registered Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 errored-div" [routerLink]="'/app/business/list'"
          [queryParams]="{action:5, status:1, type:21}">
          <h3>{{dashboard.total_disabled_accounts ? dashboard.total_disabled_accounts : '0.00'}}</h3>
          <h4 class="m-0">Transfers Disabled Accounts</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-5 p-2 highlighted-div" [routerLink]="'/app/business/list'" [queryParams]="{type: 15}">
          <h3>{{dashboard.active_doctors_this_month ? dashboard.active_doctors_this_month : '0.00'}}</h3>
          <h4 class="m-0">Active Businesses This Month</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-4 p-2 highlighted-div" [routerLink]="'/app/business/list'" [queryParams]="{type: 14}">
          <h3>{{dashboard.active_doctors_this_month_30 ? dashboard.active_doctors_this_month_30 : '0.00'}}</h3>
          <h4 class="m-0">Active Businesses In Last 30 Days</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-4 p-2 highlighted-div" [routerLink]="'/app/business/list'"
          [queryParams]="{type: 4, status:1}">
          <h3>{{dashboard.total_business_without_bank ? dashboard.total_business_without_bank : '0.00'}}</h3>
          <h4 class="m-0">Businesses Without Bank Account</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-4 p-2 highlighted-div" [routerLink]="'/app/business/list'"
          [queryParams]="{type: 23, status:1}">
          <h3>{{dashboard.total_business_without_training ? dashboard.total_business_without_training : '0.00'}}</h3>
          <h4 class="m-0">Businesses With No Training</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-4 p-2 highlighted-div" [routerLink]="'/app/business/list'"
          [queryParams]="{type: 13, status:1}">
          <h3>{{dashboard.total_business_without_approved ? dashboard.total_business_without_approved : '0.00'}}</h3>
          <h4 class="m-0">Businesses Not Approved</h4>
        </div>
      </div>
      <!-- <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-4 p-2 highlighted-div">
        <h3>{{dashboard.total_no_of_free ? dashboard.total_no_of_free : '0.00'}}</h3>
        <h4 class="m-0">Free Subscription</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-4 p-2 highlighted-div">
        <h3>{{dashboard.total_no_of_Platinum ? dashboard.total_no_of_Platinum : '0.00'}}</h3>
        <h4 class="m-0">Platinum Subscription</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-4 p-2 highlighted-div">
        <h3>{{dashboard.total_no_of_Gold ? dashboard.total_no_of_Gold : '0.00'}}</h3>
        <h4 class="m-0">Gold Subscription</h4>
      </div>
    </div>
    <div class="col-md-3 col-sm-6 col-12 mb-3">
      <div class="card bg-4 p-2 highlighted-div">
        <h3>{{dashboard.total_no_of_Silver ? dashboard.total_no_of_Silver : '0.00'}}</h3>
        <h4 class="m-0">Sliver Subscription</h4>
      </div>
    </div> -->
  </div>
</accordion-group>
}

@if (!_shared.routerAuth.restricted_buttons.patient_stats) {
  <accordion-group  class="mb-3 financed-contracts-accordion" heading="Customers" [isOpen]="opened" [panelClass]="'dashboard-cards'"
    >
    <div class="row ">
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-6 p-2" [routerLink]="'/app/customers'" [queryParams]="{filter:1, type:1, status:2}">
          <h3>{{dashboard.active_patients ? dashboard.active_patients : '0.00'}}</h3>
          <h4 class="m-0">Customers with Contract</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-7 p-2" [routerLink]="'/app/customers'" [queryParams]="{filter:2, type:2, status:2}">
          <h3>{{dashboard.patients_without_contracts ? dashboard.patients_without_contracts : '0.00'}}</h3>
          <h4 class="m-0">Customers without Contract</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-8 p-2" [routerLink]="'/app/customers'"
          [queryParams]="{startDate:today_start_date, endDate:today_end_date}">
          <h3>{{dashboard.new_patients_today ? dashboard.new_patients_today : '0.00'}}</h3>
          <h4 class="m-0">Customers Registered Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-8 p-2">
          <h3>{{dashboard.self_verified_customers ? dashboard.self_verified_customers : '0.00'}}</h3>
          <h4 class="m-0">Self Verified Customers</h4>
        </div>
      </div>
    </div>
  </accordion-group>
}

@if (!_shared.routerAuth.restricted_buttons.split_request_stats) {
  <accordion-group  class="mb-3 financed-contracts-accordion" heading="Debt Recovery" [isOpen]="opened" [panelClass]="'dashboard-cards'"
    >
    <div class="row">
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 normal-div">
          <h3>${{dashboard.ar_v2_total_debt_recovered}}</h3>
          <h4 class="m-0">Total Debt Recovered</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 highlighted-div normal-div">
          <h3>${{dashboard.ar_v2_total_debt_recovered_today}}</h3>
          <h4 class="m-0"> Total Debt Recovered Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-7 p-2" [routerLink]="'/app/debt-recovery/list'"
          [queryParams]="{status:0, activeStatus:-1, by:'date_added' ,order:'DESC', sortBy:1, ProposalType:1}">
          <h3>{{dashboard.ar_v2_total_proposals}}</h3>
          <h4 class="m-0">Total Debt Recoveries Initiated</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-8 p-2 highlighted-div" [routerLink]="'/app/debt-recovery/list'"
          [queryParams]="{status:0, activeStatus:-1, by:'date_added' ,order:'DESC', sortBy:1, ProposalType:1, startDate: today_start_date, endDate: today_end_date}">
          <h3>{{dashboard.ar_v2_total_proposals_today}}</h3>
          <h4 class="m-0">Total Debt Recoveries Initiated Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2" [routerLink]="'/app/debt-recovery/list'" [queryParams]="{status:13, page:1,last_resent:0,ProposalType:0}">
          <h3>{{dashboard.ar_v2_total_paid_off}}</h3>
          <h4 class="m-0">Total Payment paid off</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 highlighted-div" [routerLink]="'/app/debt-recovery/list'"
          [queryParams]="{status:13, page:0, startDate: today_start_date, endDate: today_end_date}">
          <h3>{{dashboard.ar_v2_total_paid_off_today}}</h3>
          <h4 class="m-0">Total Payment paid off Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2" [routerLink]="'/app/contracts/list'"
          [queryParams]="{type:1, sort:1, page:1, extraFilter:29}">
          <h3>{{dashboard.ar_v2_total_contracts}}</h3>
          <h4 class="mb-0">Total Debt Recovery Contracts </h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <!-- [queryParams]="{type:0, sort:1, page:1,extraFilter:29, sD: today_start_date, eD: today_end_date}"> -->
        <div class="card bg-5 p-2 highlighted-div" [routerLink]="'/app/contracts/list'"
          [queryParams]="{type:0,extraFilter:29, sD: today_start_date, eD: today_end_date}">
          <h3>{{dashboard.ar_v2_total_contracts_today}}</h3>
          <h4 class="m-0">Total Debt Recovery Contracts Today</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h3>{{dashboard.ar_v2_delivered_emails}}</h3>
          <h4 class="m-0">Emails Reminders Delivered</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h3>{{dashboard.ar_v2_failed_emails}}</h3>
          <h4 class="m-0">Emails Reminders Failed</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-6 p-2 highlighted-div normal-div">
          <h3>{{dashboard.ar_v2_delivered_sms}}</h3>
          <h4 class="m-0">SMS Reminders Delivered</h4>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 col-12 mb-3">
        <div class="card bg-3 p-2 errored-div normal-div">
          <h3>{{dashboard.ar_v2_failed_sms}}</h3>
          <h4 class="m-0">SMS Reminders Failed</h4>
        </div>
      </div>
    </div>
  </accordion-group>
}
</accordion>

</div>